/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  CreateEventRegistrationDto,
  EventRegistrationDetailDto,
  EventRegistrationDto,
  GetMyEventRegistrationsV1Params
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type registerEventV1Response201 = {
  data: EventRegistrationDto
  status: 201
}

export type registerEventV1Response400 = {
  data: void
  status: 400
}

export type registerEventV1Response401 = {
  data: void
  status: 401
}

export type registerEventV1Response403 = {
  data: void
  status: 403
}

export type registerEventV1Response404 = {
  data: void
  status: 404
}

export type registerEventV1Response409 = {
  data: void
  status: 409
}

export type registerEventV1Response422 = {
  data: void
  status: 422
}

export type registerEventV1Response502 = {
  data: void
  status: 502
}

export type registerEventV1ResponseSuccess = (registerEventV1Response201) & {
  headers: Headers;
};
export type registerEventV1ResponseError = (registerEventV1Response400 | registerEventV1Response401 | registerEventV1Response403 | registerEventV1Response404 | registerEventV1Response409 | registerEventV1Response422 | registerEventV1Response502) & {
  headers: Headers;
};

export type registerEventV1Response = (registerEventV1ResponseSuccess | registerEventV1ResponseError)

export const getRegisterEventV1Url = (id: string,) => {




  return `/api/v1/me/events/${id}/registrations`
}

/**
 * Self-registration on an event whose bookingMode is "Salesforce". Contract §3.3 + delta v1.12 §3 — the registration targets an occurrence.
 *
 * Body:
 * - occurrenceId: the id from the detail's occurrences[] — MANDATORY when the event has more than one occurrence (400 occurrence_required), optional with exactly one (the single occurrence is used), unknown for this event → 404.
 * - numberOfGuests: integer ≥ 0 — the whole party, member included (0 and 1 both mean the member alone; the stored party is never below 1), the single source of truth for the party size. MuleSoft receives the companions (numberOfGuests − 1, contract §3.4) and the stored count is the party again.
 * - source: optional; the only accepted value is "APP" (also the default) — the origin is not client-assignable.
 * - payment: only for paid events, after the Stripe payment completed on the client ({ reference: PaymentIntent pi_…, amount, currency }) — MuleSoft materializes the Order.
 *
 * 201 response: { id, status, occurrenceId, numberOfGuests, registrationDate, availableSpots } — availableSpots is the registered occurrence's authoritative value (null outside Salesforce-booked events, which have no seat count).
 *
 * Salesforce owns the per-occurrence validations: 409 not enough seats — never "already registered", a new POST on the same date updates the registration — answered with code event_sold_out and availableSpots (the seats left, read from Salesforce at that moment; null when that read failed) so the app can offer fewer guests; 422 not published / registration deadline passed; 400 guests over the limit (the limit counts companions); 403 membership ownership. Requires the Idempotency-Key header (24h dedupe). Events whose booking lives in another channel (SevenRooms, Concierge, External) return 422 flow_mismatch — book those through their own flow.
 * @summary Register on a brand event (bookingMode Salesforce)
 */
export const registerEventV1 = async (id: string,
    createEventRegistrationDto: CreateEventRegistrationDto, options?: Parameters<typeof customFetch>[1]): Promise<registerEventV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<registerEventV1Response>(getRegisterEventV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createEventRegistrationDto)
  }
);}


export type getMyEventRegistrationsV1Response200 = {
  data: EventRegistrationDetailDto[]
  status: 200
}

export type getMyEventRegistrationsV1Response400 = {
  data: void
  status: 400
}

export type getMyEventRegistrationsV1Response401 = {
  data: void
  status: 401
}

export type getMyEventRegistrationsV1ResponseSuccess = (getMyEventRegistrationsV1Response200) & {
  headers: Headers;
};
export type getMyEventRegistrationsV1ResponseError = (getMyEventRegistrationsV1Response400 | getMyEventRegistrationsV1Response401) & {
  headers: Headers;
};

export type getMyEventRegistrationsV1Response = (getMyEventRegistrationsV1ResponseSuccess | getMyEventRegistrationsV1ResponseError)

export const getGetMyEventRegistrationsV1Url = (params?: GetMyEventRegistrationsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/events/registrations?${stringifiedParams}` : `/api/v1/me/events/registrations`
}

/**
 * The member's brand-event registrations — the booking area. scope=upcoming (default): active registrations whose reserved date (occurrence, else event) is ahead, soonest first; scope=past: finished ones (terminal status or date passed), most recent first. Each row = { registration (with occurrenceId), event card, occurrence (the booked date/venue) }.
 *
 * Before answering, the API refreshes the member's registrations from MuleSoft (§3.8 — the startup sync's second call; registrations do NOT arrive with the register response). The refresh is best-effort: when MuleSoft is unreachable, the local data is served anyway.
 * @summary The member's event registrations (Os Meus Eventos)
 */
export const getMyEventRegistrationsV1 = async (params?: GetMyEventRegistrationsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMyEventRegistrationsV1Response> => {

  return customFetch<getMyEventRegistrationsV1Response>(getGetMyEventRegistrationsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getEventRegistrationV1Response200 = {
  data: EventRegistrationDetailDto
  status: 200
}

export type getEventRegistrationV1Response401 = {
  data: void
  status: 401
}

export type getEventRegistrationV1Response404 = {
  data: void
  status: 404
}

export type getEventRegistrationV1ResponseSuccess = (getEventRegistrationV1Response200) & {
  headers: Headers;
};
export type getEventRegistrationV1ResponseError = (getEventRegistrationV1Response401 | getEventRegistrationV1Response404) & {
  headers: Headers;
};

export type getEventRegistrationV1Response = (getEventRegistrationV1ResponseSuccess | getEventRegistrationV1ResponseError)

export const getGetEventRegistrationV1Url = (registrationId: string,) => {




  return `/api/v1/me/events/registrations/${registrationId}`
}

/**
 * Returns the caller's registration by the id returned on register — the booking confirmation/details page: the registration (id/status/occurrenceId/numberOfGuests/registrationDate), the event card (same shape as the listing) and the booked occurrence (date, venue, venueNodeKey, price) when the event has occurrences. Ownership enforced — someone else's registration is a plain 404.
 * @summary One event registration (booking details)
 */
export const getEventRegistrationV1 = async (registrationId: string, options?: Parameters<typeof customFetch>[1]): Promise<getEventRegistrationV1Response> => {

  return customFetch<getEventRegistrationV1Response>(getGetEventRegistrationV1Url(registrationId),
  {
    ...options,
    method: 'GET'


  }
);}


export type cancelEventRegistrationV1Response204 = {
  data: void
  status: 204
}

export type cancelEventRegistrationV1Response401 = {
  data: void
  status: 401
}

export type cancelEventRegistrationV1Response403 = {
  data: void
  status: 403
}

export type cancelEventRegistrationV1Response404 = {
  data: void
  status: 404
}

export type cancelEventRegistrationV1Response409 = {
  data: void
  status: 409
}

export type cancelEventRegistrationV1Response502 = {
  data: void
  status: 502
}

export type cancelEventRegistrationV1ResponseSuccess = (cancelEventRegistrationV1Response204) & {
  headers: Headers;
};
export type cancelEventRegistrationV1ResponseError = (cancelEventRegistrationV1Response401 | cancelEventRegistrationV1Response403 | cancelEventRegistrationV1Response404 | cancelEventRegistrationV1Response409 | cancelEventRegistrationV1Response502) & {
  headers: Headers;
};

export type cancelEventRegistrationV1Response = (cancelEventRegistrationV1ResponseSuccess | cancelEventRegistrationV1ResponseError)

export const getCancelEventRegistrationV1Url = (registrationId: string,) => {




  return `/api/v1/me/events/registrations/${registrationId}/cancel`
}

/**
 * Cancels the caller's registration (the id returned by the register endpoint). Only free registrations can be cancelled in-app — paid ones go through the concierge (403, no in-app refunds); already-cancelled or terminal states return 409. Relays to MuleSoft (§3.4, X-Entra-Id anti-IDOR) and updates the local registration.
 * @summary Cancel a brand-event registration
 */
export const cancelEventRegistrationV1 = async (registrationId: string, options?: Parameters<typeof customFetch>[1]): Promise<cancelEventRegistrationV1Response> => {

  return customFetch<cancelEventRegistrationV1Response>(getCancelEventRegistrationV1Url(registrationId),
  {
    ...options,
    method: 'POST'


  }
);}


